import { useState, useEffect } from 'react'
import { Users, ShieldCheck } from 'lucide-react'
import { getAdminUsers } from '../../lib/api'

export default function AdminCustomers() {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getAdminUsers().then(data => { setUsers(data || []); setLoading(false) }).catch(() => setLoading(false))
  }, [])

  if (loading) return <div className="p-8 flex items-center justify-center h-full"><div className="w-8 h-8 border-2 border-flight-cyan border-t-transparent rounded-full animate-spin" /></div>

  return (
    <div className="p-8">
      <div className="mb-8"><h1 className="text-2xl font-bold text-white">Customers</h1><p className="text-slate-400 text-sm">{users.length} registered users</p></div>
      <div className="glass-panel overflow-hidden">
        <table className="w-full">
          <thead><tr className="border-b border-slate-700">
            <th className="text-left p-4 text-slate-400 text-xs font-medium">User</th>
            <th className="text-left p-4 text-slate-400 text-xs font-medium">Role</th>
            <th className="text-left p-4 text-slate-400 text-xs font-medium">Country</th>
            <th className="text-left p-4 text-slate-400 text-xs font-medium">2FA</th>
            <th className="text-left p-4 text-slate-400 text-xs font-medium">Stripe Customer</th>
            <th className="text-left p-4 text-slate-400 text-xs font-medium">Joined</th>
          </tr></thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id} className="border-b border-slate-800/50 hover:bg-slate-800/20">
                <td className="p-4"><div className="flex items-center gap-3"><div className="w-8 h-8 rounded-full bg-flight-cyan/20 flex items-center justify-center text-flight-cyan text-xs font-bold">{u.email?.charAt(0).toUpperCase()}</div><div><div className="text-white text-sm font-medium">{u.name || u.email}</div><div className="text-slate-500 text-xs">{u.email}</div></div></div></td>
                <td className="p-4"><span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium capitalize ${u.role === 'admin' ? 'bg-flight-violet/10 text-flight-violet' : 'bg-slate-700 text-slate-400'}`}>{u.role === 'admin' && <ShieldCheck className="w-3 h-3" />}{u.role}</span></td>
                <td className="p-4 text-slate-300 text-sm">{u.country || '---'}</td>
                <td className="p-4 text-slate-400 text-sm">{u.totp_enabled ? 'Enabled' : '---'}</td>
                <td className="p-4 text-slate-400 text-xs font-mono">{u.stripe_customer_id || '---'}</td>
                <td className="p-4 text-slate-400 text-sm">{u.created_at ? new Date(u.created_at).toLocaleDateString() : '---'}</td>
              </tr>
            ))}
            {users.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-slate-500 text-sm"><Users className="w-6 h-6 mx-auto mb-2 opacity-50" />No customers yet</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  )
}
